<template>
  <section class="containerCircularButton" :class="{main: main}" @click="clickOutsideHandler">
    <span @click.stop.prevent="$emit('click', $event)"><slot name="label" class="label"></slot></span>
    <button class="containerCircularButton__button" @click.stop.prevent="$emit('click', $event)">
      <slot name="icon"></slot>
    </button>
  </section>
</template>

<script>
export default {
  props: {
    main: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    
    /**
     * @description Cancels the normal behaviour of the click event and notify a click outside of the button has been fired.
     * @param {Event} event fired by the user.
     */
    function clickOutsideHandler (event) {
      event.stopImmediatePropagation()
      event.preventDefault()
      event.stopPropagation()
      emit('clickOutside')
    }

    return {
      clickOutsideHandler
    }
  }
}
</script>
